
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"s-live-poll-answer\" data-answer-id=\"{{id}}\">\r\n    <div class=\"s-live-poll-answer__inner-wrap\">\r\n        {{title}}\r\n    </div>\r\n</div>");